import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icon/icon-success.png'


const _withScopeId = n => (_pushScopeId("data-v-dad24126"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dialog-success" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "icon",
    src: _imports_0
  }),
  /*#__PURE__*/_createElementVNode("div", { class: "content" }, " Complete purchase ")
], -1))
const _hoisted_2 = { class: "step-confirm" }
const _hoisted_3 = { class: "section" }
const _hoisted_4 = { class: "section" }
const _hoisted_5 = { class: "box-submit" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Complete purchase ")

import { ref } from 'vue';
  import { ColorVariants } from '@/constants';
  import InfoBill from './info-bill-address.vue';
  import InfoPayment from './info-payment.vue';
  import InfoAddress from './info-address.vue';
  import { CheckoutStore } from '@/stores';

  interface IProps {
    store: CheckoutStore
  }

  
export default /*#__PURE__*/_defineComponent({
  props: {
    store: null
  },
  setup(__props: any) {

  

  const dialogVisible = ref(false);


return (_ctx: any,_cache: any) => {
  const _component_AppDialog = _resolveComponent("AppDialog")!
  const _component_AppLoadingButton = _resolveComponent("AppLoadingButton")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_AppDialog, {
      visible: dialogVisible.value,
      "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((dialogVisible).value = $event)),
      class: "dialog-success-container",
      btns: [{ text: 'Close', style: _unref(ColorVariants).primary, click: () => dialogVisible.value = false } ]
    }, {
      default: _withCtx(() => [
        _hoisted_1
      ]),
      _: 1
    }, 8, ["visible", "btns"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(InfoAddress, {
          readonly: "",
          store: __props.store
        }, null, 8, ["store"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(InfoPayment, { readonly: "" })
      ]),
      _createVNode(InfoBill, { readonly: "" }),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_AppLoadingButton, {
          class: "btn-submit",
          pill: "",
          variant: _unref(ColorVariants).primary
        }, {
          default: _withCtx(() => [
            _hoisted_6
          ]),
          _: 1
        }, 8, ["variant"])
      ])
    ])
  ], 64))
}
}

})